import { useEffect, useRef } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import './TidioChat.css';

const TidioChat = () => {
  const loadedRef = useRef(false);
  const { hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasMarketingConsent) return;
    const loadTidio = () => {
      // Only load once
      if (loadedRef.current) return;
      if (window.tidioChatApi || document.querySelector('script[src*="code.tidio.co"]')) {
        loadedRef.current = true;
        return;
      }

      const tidioPublicKey = process.env.REACT_APP_TIDIO_PUBLIC_KEY || 'your_public_key';
      if (tidioPublicKey === 'your_public_key') return;

      loadedRef.current = true;

      const script = document.createElement('script');
      script.src = `//code.tidio.co/${tidioPublicKey}.js`;
      script.async = true;

      script.onerror = () => {
        console.warn('Failed to load Tidio chat widget');
      };

      script.onload = () => {
        if (window.tidioChatApi) {
          window.tidioChatApi.on('ready', function() {
            window.tidioChatApi.setVisitorData({
              distinct_id: 'visitor_' + Date.now(),
              source: 'website',
              page: window.location.pathname,
              timestamp: new Date().toISOString()
            });
          });
        }
      };

      document.head.appendChild(script);
    };

    // Defer Tidio loading until user interacts or 8 seconds pass (whichever comes first).
    // This keeps the widget available but avoids blocking initial page metrics.
    const timer = setTimeout(loadTidio, 8000);

    const onInteraction = () => {
      loadTidio();
      cleanup();
    };

    const events = ['scroll', 'click', 'touchstart', 'mousemove'];
    events.forEach(e => window.addEventListener(e, onInteraction, { once: true, passive: true }));

    const cleanup = () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, onInteraction));
    };

    return cleanup;
  }, [hasMarketingConsent]);

  return null;
};

export default TidioChat;
